import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { usePost, fetchPost } from "utils/api";
import { useQuery, usePagination } from "utils/gql";
import View from "components/crh/processes/Processes.view";

function Processes() {

  const payrollPeriodPageSize = 10;
  const [payrollPeriodPage, setPayrollPeriodPage] = useState(1);

  const employeePageSize = 10;
  const [employeePage, setEmployeePage] = useState(1);

  const [selectedOffices, setSelectedOffices] = useState({});
  const [selectedPayroll, setSelectedPayroll] = useState({});
  const [selectedPayrollPeriod, setSelectedPayrollPeriod] = useState({});
  const [selectedEmployees, setSelectedEmployees] = useState({});
  const [search, setSearch] = useState("");

  const reqOffices = useQuery(`
      Office {
        result {
          id
          key
          description
          abbreviation
        }
      }
    `, {
    order: [
      ["key", "DESC"]
    ]
  }, {
    onError: (error) => {
      if (!toast.isActive("toast-offices-eror"))
        toast.error("Error al obtener las sucursales", { toastId: "toast-offices-eror" })
    }
  });

  const reqPayrolls = useQuery(`
      Payroll {
        result {
          id
          key
          description
          abbreviation
        }
      }
    `, {
    order: [
      ["key", "DESC"]
    ]
  }, {
    onError: (error) => {
      if(!toast.isActive("toast-payrolls-eror"))
        toast.error("Error al obtener los tipos de nóminas", { toastId: "toast-payrolls-eror" })
    }
  });

  const reqPayrollPeriods = usePagination(`
    PayrollPeriod {
      totalPages
      result {
        id
        description
      }
    }
  `, payrollPeriodPage, payrollPeriodPageSize, {
    cancel: !selectedPayroll?.id,
    where: {
      payroll_id: {
        eq: selectedPayroll.id
      }
    },
    order: [
      ["createdAt", "DESC"]
    ]
  }, {
    onError: (error) => {
      if (!toast.isActive("toast-payrollPeriods-eror"))
        toast.error("Error al obtener los periodos de nómina", { toastId: "toast-payrollPeriods-eror" })
    }
  });

  const reqEmployees = usePagination(`
    Employee {
      totalPages
      result {
        id
        key
        firstname
        dad_lastname
        mom_lastname
      }
    }
  `, employeePage, employeePageSize, {
    cancel: !(Object.keys(selectedOffices).reduce((acc, key) => acc || selectedOffices[key], false) && 
      Object.keys(selectedPayroll).reduce((acc, key) => acc || selectedPayroll[key], false)),
    where: {
      office_id: {
        in: Object.keys(selectedOffices).filter((id) => selectedOffices[id])
      },
      payroll_id: {
        eq: selectedPayroll?.id
      },
      status: {
        eq: "ACTIVE"
      },
      register_crh: {
				eq: true
			},
      ...(
				search 
					? {
							ilike_concat: {
								fields: [
									"pin",
									"Employee.key",
									"firstname",
									"dad_lastname",
									"mom_lastname",
									"email"
								],
								value: search
							}
						}
					: {}
			),
    },
    order: [
      ["pin", "ASC"]
    ]
  }, {
    onError: (error) => {
      if (!toast.isActive("toast-employees-eror"))
        toast.error("Error al obtener los empleados", { toastId: "toast-employees-eror" })
    }
  });

  const [callExecution, reqExecution] = usePost("/processes", {
    onCompleted: () => {
      // if(!toast.isActive("regime-created"))
      // toast.success("Régimen creado correctamente", {toastId : "regime-created"});
    },
    onError: (err) => {

      console.error(err)

      if (!toast.isActive("active-processes-error") && err.status === 401)
        toast.error("Ya hay procesos activos, por favor espere a que terminen para iniciar otro", { toastId: "active-processes-error" });

      if (!toast.isActive(`toast-create-processes-unauthorized`) && err.status === 403)
        toast.error(`Error, no tienes los permisos para crear procesos`, { toastId: `toast-create-processes-unauthorized` })

      if (!toast.isActive("data-process-error") && err.status === 400)
        toast.error("Error, por favor revise que haya seleccionado una nómina y un periodo de nómina", { toastId: "data-process-error" });

      if (!toast.isActive("process-error") && err.status === 500)
        toast.error("Error interno del servidor, por favor vuelva a intentarlo mas tarde", { toastId: "process-error" });
    }

  })

  const onChangePayroll = (payroll) =>
    setSelectedPayroll(payroll)

  const onCheckOffice = (id) => {
    setSelectedOffices({
      ...selectedOffices,
      [id]: selectedOffices[id] ? false : true
    })
  }

  const onExecute = () => {

    fetchPost("/permissions/check", { table: "INCIDENCE_PROCESS", permission: "create" }).then((response) => {
      if (response.data) {
        const data = response.data;
        if (data.isAllowed === true) {

          const officesIds = Object.keys(selectedOffices).filter((id) => selectedOffices[id])
          if (selectedPayroll.id === undefined || selectedPayrollPeriod.id === undefined) {
            if (!toast.isActive("data-process-error"))
              toast.error("Seleccione una nómina y un periodo de nómina primero", { toastId: "data-process-error" });
            return;
          }

          const employeesIds = Object.keys(selectedEmployees).filter((id) => selectedEmployees[id])

          callExecution({
            offices: officesIds,
            employees: employeesIds,
            payrollPeriod: selectedPayrollPeriod,
            payroll: selectedPayroll
          })

        } else {
          if (!toast.isActive("toast-create-processes-unauthorized")) {
            toast.error("Error, no tienes los permisos para crear procesos", { toastId: "toast-create-processes-unauthorized" })
          }
        }
      }
    })

  }

  const offices = reqOffices.data?.result || [];
  const payrolls = reqPayrolls.data?.result || [];
  const payrollPeriods = reqPayrollPeriods.data?.result || [];
  const payrollPeriodTotalPages = reqPayrollPeriods.data?.totalPages || 0;

  const employees = reqEmployees.data?.result || [];
  const employeesTotalPages = reqEmployees.data?.totalPages || 0;

  return <View

    search={search}
    setSearch={setSearch}

    selectedEmployees={selectedEmployees}
    setSelectedEmployees={setSelectedEmployees}

    employees={employees}
    employeesPage={employeePage}
    setEmployeesPage={setEmployeePage}
    employeesTotalPages={employeesTotalPages}
    
    payrollPeriods={payrollPeriods}
    payrollPeriodPage={payrollPeriodPage}
    setPayrollPeriodPage={setPayrollPeriodPage}
    payrollPeriodTotalPages={payrollPeriodTotalPages}

    offices={offices}
    payrolls={payrolls}
    selectedOffices={selectedOffices}
    selectedPayroll={selectedPayroll}
    selectedPayrollPeriod={selectedPayrollPeriod}
    onChangePayroll={onChangePayroll}
    onCheckOffice={onCheckOffice}
    setSelectedPayroll={setSelectedPayroll}
    setSelectedPayrollPeriod={setSelectedPayrollPeriod}
    onExecute={onExecute}
  />;

}

export default Processes;